"use client";

/**
 * Presenter-chrome subcomponent: static hotkeys legend.
 * Two-column grid of keybinding hints. Display-only.
 */
export function HotkeysLegend() {
  return (
    <>
      <p className="mt-3 text-orbitra-teal-soft uppercase tracking-[0.18em]">Hotkeys</p>
      <ul className="mt-1 grid grid-cols-2 gap-1 text-[9px] text-orbitra-muted">
        <li>E · I · perspective</li>
        <li>N · next screen</li>
        <li>⇧N · prev screen</li>
        <li>⇧B · prev act</li>
        <li>D · re-open sign doc</li>
        <li>J · event log inspector</li>
        <li>? · chrome</li>
        <li>⌘, · help</li>
      </ul>
    </>
  );
}
